import scheduled from "./scheduled/";
import defaultConfig from "./default/";
import exception from "./exception/";
import outstanding from "./outstanding/";
import openclosebyarea from "./openclosebyarea/"; // 09/21 - open close by area
import failedtoclose from "./failedtoclose/";

const config = {
  default: defaultConfig,
  scheduled,
  exception,
  outstanding,
  openclosebyarea,
  failedtoclose,
};

export default config;